import { render, staticRenderFns } from "./ReportByModuleByMonthTable.vue?vue&type=template&id=2d2a36fa&scoped=true&"
import script from "./ReportByModuleByMonthTable.vue?vue&type=script&lang=js&"
export * from "./ReportByModuleByMonthTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2a36fa",
  null
  
)

export default component.exports